<template>
  <button
    type="submit"
    class="relative rounded-full bg-primary px-3 py-1 text-lg text-primary-fg disabled:pointer-events-none disabled:opacity-40"
    :disabled="isLoading"
  >
    <slot> Save </slot>
    <BaseInnerLoading v-if="isLoading" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  isLoading?: boolean
}>()
</script>
